<template>
<v-text-field ref="date" :value="value" @blur="isDate" @keypress="upDown" v-bind="$attrs" v-on="$listeners" :rules="requiredRules" @input="v => $emit('input', v)" maxLength="10" v-mask="'####/##/##'" prepend-inner-icon="mdi-calendar-text" />
</template>
<script>
//
import {
  toJalaali,
  toMiladi,
  isValidJalaaliDate
} from '../functions/myDate'

export default {
  name: 'MyDate',
  props: {
    value: {
      // type: String,
      required: true,
    },
    refs: {
      type: Boolean
    },
  },
  data() {
    return {
      requiredRules: [
        v => !!v || 'فیلد اجباری',
      ],
    }
  },
  mounted() {
    if (this.refs === true) {
      this.$refs.date.focus()
    }
  },
  methods: {
    isDate(e) {
      let valid = isValidJalaaliDate(e.target.value);
      // console.log(valid);
      if (!valid) {
        let jdate = toJalaali(new Date()).date;
        this.$emit('setValue', jdate)
      }
    },
    upDown(e) {
      // console.log(toJalaali(new Date()));
      if (e.key === '+' || e.key === '-') {
        let jdate,
          date;
        let valid = isValidJalaaliDate(event.target.value);
        if (valid) {
          jdate = event.target.value;
          date = toMiladi(jdate);
          if (event.key === '+') {
            //
            date.setDate(date.getDate() + 1);
            jdate = toJalaali(date).date;
            this.$emit('setValue', jdate)
          } else if (event.key === '-') {
            //
            date.setDate(date.getDate() - 1);
            jdate = toJalaali(date).date;
            this.$emit('setValue', jdate)
          }
        } else {
          jdate = toJalaali(new Date()).date;
          this.$emit('setValue', jdate)
        }
      }
      if (e.key === 'Enter') {
        //
      } else if (isNaN(Number(e.key))) {
        return e.preventDefault()
      }
    }
  },
}
</script>
